import InputType from "./inputType/InputType";
import ButtonType from "./ButtonType/ButtonType";
import Loading from "./Loader/Loading";
import Datecomp from "./DateType/dateType";
import PageLoader from "./Loader/PageLoader";

export {InputType, ButtonType, Loading, Datecomp, PageLoader};